<template>
  <header>
    <button class="toggle_menu" :class="{is_active: isSidebarOpen}" @click="menuClick">
      <span class="menu">menu</span>
    </button>

    <div class="crumb">
      <ul>
        <li><a>CMS</a></li>
        <li v-for="(part, index) in topbarTitle" :key="index">
          <router-link v-if="(part instanceof Object)" :to="part.link"> {{ part.name }}</router-link>
          <span v-else> {{ part }}</span>
        </li>
      </ul>
    </div>

    <language-select></language-select>

    <ul class="links" v-bind:class="{is_active: isSidebarOpen}">
      <logout-button></logout-button>
    </ul>
  </header>
</template>

<script>
import { mapState } from 'vuex'
import LogoutButton from 'components/LogoutButton'
import { LAYOUT_SET_SIDEBAR_OPEN } from 'store/modules/layout'
import LanguageSelect from '../../components/AppContent/LanguageSelect'

export default {
  name: 'top-bar',
  components: {
    LogoutButton,
    LanguageSelect
  },
  computed: {
    ...mapState({
      isSidebarOpen: state => state.layout.isSidebarOpen,
      topbarTitle: state => state.layout.topbarTitle
    })
  },
  methods: {
    menuClick() {
      this.$store.commit({
        type: LAYOUT_SET_SIDEBAR_OPEN,
        open: !this.isSidebarOpen
      })
    }
  }
}
</script>
